import { alpha, PaletteMode, PaletteOptions } from '@mui/material';
import { GetThemeOptions } from '../theme';
import {
  unitySemanticDarkColorTokens,
  unitySemanticLightColorTokens,
  xcorDefinedDarkTokens,
  xcorDefinedLightTokens,
} from '../unityTokens';
import { blue, green, grey, white } from './colors';
import { buildPaletteFromMetadata, type Token } from './panw-palette/token-metadata';

const backgroundTokens = [
  { propertyPath: 'navigation', tokenName: '--semantic-bg-surface-base' },
  { propertyPath: 'overlay', tokenName: '--semantic-bg-surface-overlay' },
  { propertyPath: 'default', tokenName: '--semantic-bg-surface-base' },
  { propertyPath: 'paper', tokenName: '--semantic-bg-surface-floating' },
  { propertyPath: 'tooltip', tokenName: '--semantic-bg-surface-floating' },
  { propertyPath: 'popover', tokenName: '--semantic-bg-surface-floating' },
  { propertyPath: 'canvas', tokenName: '--semantic-bg-surface-base' },
  { propertyPath: 'container', tokenName: '--semantic-bg-surface-page-container' },
  { propertyPath: 'hover', tokenName: '--semantic-bg-interactive-neutral-hover' },
  { propertyPath: 'selected', tokenName: '--semantic-bg-interactive-neutral-active' },
  { propertyPath: 'surface.hover', tokenName: '--bg-hover' },
  { propertyPath: 'surface.selected', tokenName: '--bg-active' },
] satisfies Token[];

export const backgroundTokenMetadata = {
  componentName: 'background',
  tokens: backgroundTokens,
};

export const background = (mode: PaletteMode, opts: GetThemeOptions): PaletteOptions['background'] => {
  if (opts.panwRebrandStubYear) {
    const semanticTokens = mode === 'light' ? unitySemanticLightColorTokens : unitySemanticDarkColorTokens;
    const xcorTokens = mode === 'light' ? xcorDefinedLightTokens : xcorDefinedDarkTokens;
    const opacity = mode === 'light' ? 0.15 : 0.7;
    const palette = buildPaletteFromMetadata<PaletteOptions['background']>(
      backgroundTokens,
      semanticTokens,
      xcorTokens
    );
    return {
      ...palette,
      backdrop: alpha(semanticTokens['--semantic-bg-surface-backdrop'], opacity),
    };
  }

  return mode === 'light'
    ? {
        navigation: grey[850],
        backdrop: alpha(grey[950], 0.7),
        overlay: alpha(grey[950], 0.7),
        default: white,
        paper: grey[50],
        tooltip: grey[900],
        popover: white,
        canvas: grey[50],
        container: white,
        hover: grey[50],
        selected: blue[50],
        surface: {
          hover: alpha(grey[300], 0.2),
          selected: green[50],
        },
      }
    : {
        navigation: grey[850],
        backdrop: alpha(grey[850], 0.7),
        overlay: alpha(grey[850], 0.7),
        default: grey[900],
        paper: grey[850],
        tooltip: grey[850],
        popover: grey[850],
        canvas: grey[950],
        container: grey[900],
        hover: grey[800],
        selected: blue[850],
        surface: {
          hover: alpha(grey[300], 0.2),
          selected: green[800],
        },
      };
};
